<template>
  <EditableArea v-if="main" :content="main" />
</template>

<script setup>
// todo: rework to composition API

defineOptions({
  inheritAttrs: false,
});
</script>

<script>
import { EditableArea } from "@magnolia/vue-editor";
import { editableComponent } from "~/utils/mixins/editableComponent";

export default {
  name: "BasicPage",
  components: {
    EditableArea,
  },
  mixins: [editableComponent],
  props: ["title", "metadata", "main"],

  data() {
    return {
      context: null,
    };
  },
};
</script>
